import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../SectionChapter';

const IndividualBoardActivity = ({ language, refs }) => {
    let boardMenu = [
        {
            id: 'tutorial.manageSplitBoardLesson.reviewPast.description',
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageSplitBoardLesson.reviewPast.explanation1"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageSplitBoardLesson.reviewPast.explanation2"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageSplitBoardLesson.reviewPast.explanation3"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageSplitBoardLesson.reviewPast.explanation4"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id="tutorial.manageSplitBoardLesson.reviewPast.explanation5"
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                </ul>
            ),
            img: [`/static/asset/img/tutorial/withText/${language.toUpperCase()}/lessonPage_MultiBoardReview.jpeg`],
        },
    ];
    return (
        <SectionChapter
            refs={refs}
            id={'section-manageSplitBoardLesson-reviewPast'}
            title={'tutorial.manageSplitBoardLesson.reviewPast.title'}
            explanations={boardMenu}
            imageTop={false}
        />
    );
};

export default IndividualBoardActivity;
